module.exports = __webpack_public_path__ + "static/media/edit.31cfd954.svg";